import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BlogList from "./Component/Blogs/BlogList.js";
import BlogDetails from "./Component/Blogs/BlogDetails";
import Navbar from "./Component/Navbar";
import HeroSection from "./Component/HeroSection";
import Radar from "./Component/Radar.js";
import Footer from "./Component/Footer";
import SecuritySection from "./Component/SecuritySection";
import FAQSection from "./Component/FAQSection";
import SecurityBanner from "./Component/SecurityBanner";
import CapitalTabs from "./Component/CampitalTabs";
import WhyUsSection from "./Component/WhyUsSection";
import EvolutionSection from "./Component/EvolutionSection";
// import AOS from "aos";
// import "aos/dist/aos.css"; // Import the AOS styles
import Feature from "./Component/Features";
import HelpingBusinesses from "./Component/HelpingBusiness.js/index.js";
import PixellComponent from "./Component/PixellComponent/index.js";
import MapChart from "./Component/MapCharts/index.js";
import WorkSection from "./Component/WorkSection/index.js";
import NewFeature from "./Component/NewFeature/index.js";
import OurProcess from "./Component/OurProcess/index.js";
import NumberSection from "./Component/NumberSection/index.js";
import NewHeroSection from "./Component/NewHeroSection/index.js";
import TestimonialCard from "./Component/TestimonialCard/index.js";
// import WhatsApp from './Component/WhatsApp/index.js';

const HomePage = () => {
  const faqs = [
    {
      question: "Is Pixell an online platform?",
      answer: "Yes Pixell is an online platform.",
    },
    {
      question: "How does Pixell Work?",
      answer:
        "Once on the platform a brand can upload a simple document stating the brief about the requirements. Our dedicated team will speak to you and understand the requirements in detail. After this step you just have to sit back and relax. All other operational tasks will be handled by Pixell Team.",
    },
    {
      question:
        "How will Pixell platform help me improve efficiency of my campaigns?",
      answer:
        "Our state of art application empowers brands with automated workflows, which saves a lot of time in case of repetitive work. It also offers consistent, accurate, and real-time visibility of the campaigns with better decision-making.",
    },
    {
      question: "Is my data secure?",
      answer:
        "Yes, your data is absolutely safe. We believe that trust is paramount in a relationship. We do not own or sell your data. We also don't pass your data to third party applications without your permission. Your data rests in our database in a completely secure and encrypted form that leaves no scope of data pilferage.",
    },
    {
      question: "How can I get updates about the development of my campaign?",
      answer:
        "Yes you can get near to real time updates on your dashboards. Get microscope level updates on the campaign at the site level at any point of time.",
    },
  ];
  // useEffect(() => {
  //   AOS.init({
  //     offset: 120,

  //     duration: 1000, // Set the duration of the animation
  //     easing: "ease-in-out", // Set the easing function
  //     once: false, // Animation will run only once
  //   });
  // }, []);
  return (
    <div>
      <HeroSection />

      {/* Acc to new design start */}
      {/* <NewHeroSection />

      <NumberSection />
      <OurProcess />

      <WorkSection />
      <TestimonialCard />
      <NewFeature />
      <WhyUsSection />
      <BlogList /> */}
      {/* Acc to new design end */}

      {/* <Radar/> */}

      <PixellComponent />
      <CapitalTabs />
      <EvolutionSection />
      <HelpingBusinesses />
      <WhyUsSection />
      <BlogList />

      {/* <Feature /> */}

      <SecurityBanner />

      {/* <SecuritySection /> */}
      <FAQSection faqs={faqs} />

      {/* whatsup component */}

      {/* <WhatsApp/> */}
    </div>
  );
};
export default HomePage;
